export const language = {
	myName: 'Mariam Razi',
	title: 'Political Consultant',
	titleMobile: 'Political Consultant',
	subtitleMobile: '',
};
